import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { HiddenProps as Props } from './types';
import {
  unhideDeviation,
  blockDeviationAuthor,
  unblockDeviationAuthor,
} from '../../Moderation/redux/actions';
import { getHighestPriorityBlockReasonForDeviation } from '../../Moderation/redux/selectors';
import { getIsLoggedIn, isUserOlderThan18 } from '../../publicSession/selectors';
import { toggleMature } from '../../publicSession/actions';
import { pushUserSettingsModal } from '../../Modals/redux/actionCreators';

type StateProps = Pick<Props, 'blockReason' | 'isLoggedIn' | 'isUserOlderThan18'>;
type DispatchProps = Pick<
  Props,
  | 'unhideDeviation'
  | 'blockDeviant'
  | 'unblockDeviant'
  | 'disableMatureFilter'
  | 'pushUserSettingsModal'
>;

type OwnProps = Omit<Props, keyof (DispatchProps & StateProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (state, { deviation }) => ({
  isLoggedIn: getIsLoggedIn(state),
  isUserOlderThan18: isUserOlderThan18(state),
  blockReason: getHighestPriorityBlockReasonForDeviation(state, deviation),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  unhideDeviation,
  blockDeviant: blockDeviationAuthor,
  unblockDeviant: unblockDeviationAuthor,
  disableMatureFilter: () => toggleMature(false),
  pushUserSettingsModal,
};

export default connect(mapStateToProps, mapDispatchToProps);
